import axios, { AxiosError } from "axios";

type NetworkInterceptorHandlers = {
  onNetworkError: () => void;
  onResponse: () => void;
};

let isInstalled = false;

// A request that never got a response (DNS failure, dropped connection,
// server down). Cancelled requests and timeouts are not treated as a lost
// connection.
const isConnectionError = (error: AxiosError): boolean => {
  if (axios.isCancel(error)) return false;
  return !error.response && error.code === AxiosError.ERR_NETWORK;
};

export const setupNetworkInterceptor = (
  handlers: NetworkInterceptorHandlers,
): void => {
  if (isInstalled) return;
  isInstalled = true;

  axios.interceptors.response.use(
    (response) => {
      try {
        handlers.onResponse();
      } catch (error) {
        console.error(error);
      }
      return response;
    },
    (error: AxiosError) => {
      try {
        if (error.response) {
          handlers.onResponse();
        } else if (isConnectionError(error)) {
          handlers.onNetworkError();
        }
      } catch (handlerError) {
        console.error(handlerError);
      }
      return Promise.reject(error);
    },
  );
};
